module.exports = __webpack_public_path__ + "img/Angiogenesis-BRCA_10X_IDC.969ed439.png";